// extracted by mini-css-extract-plugin
export default {"wrapper":"search_wrapper__M9vN-"};